/**
 * Velvoria Home — Hover-to-open menu
 *
 * Opens header <details> menus on cursor hover (desktop only).
 * - 90ms enter delay  -> prevents accidental opens when crossing the bar
 * - 240ms leave delay -> lets the user move cursor between summary and panel
 * - Disabled on touch / no-hover devices (mobile keeps tap behavior intact)
 * - Closes other open menus on hover (single-open behavior)
 * - Click on summary still works (toggle), keyboard nav untouched
 * - Closes on Escape and on clicks outside
 */
(function () {
  'use strict';

  // Only enable on devices that actually support hover (skip touch)
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    return;
  }

  var ENTER_DELAY = 90;
  var LEAVE_DELAY = 240;

  var headerMenus = document.querySelectorAll('header-menu');
  if (!headerMenus.length) return;

  var openTimers = new WeakMap();
  var closeTimers = new WeakMap();

  function openMenu(headerMenu) {
    var details = headerMenu.querySelector('details');
    if (!details) return;

    // Close all sibling header menus first (single-open behavior)
    headerMenus.forEach(function (other) {
      if (other === headerMenu) return;
      var otherDetails = other.querySelector('details');
      if (otherDetails && otherDetails.open) otherDetails.open = false;
    });

    if (!details.open) {
      details.open = true;
      // Notify Shopify's custom <header-menu> element so it can run its own logic
      details.dispatchEvent(new Event('toggle', { bubbles: true }));
    }
  }

  function closeMenu(headerMenu) {
    var details = headerMenu.querySelector('details');
    if (!details || !details.open) return;
    details.open = false;
    details.dispatchEvent(new Event('toggle', { bubbles: true }));
  }

  function scheduleOpen(headerMenu) {
    clearTimeout(closeTimers.get(headerMenu));
    closeTimers.delete(headerMenu);
    if (openTimers.has(headerMenu)) return;
    var t = setTimeout(function () {
      openTimers.delete(headerMenu);
      openMenu(headerMenu);
    }, ENTER_DELAY);
    openTimers.set(headerMenu, t);
  }

  function scheduleClose(headerMenu) {
    clearTimeout(openTimers.get(headerMenu));
    openTimers.delete(headerMenu);
    if (closeTimers.has(headerMenu)) return;
    var t = setTimeout(function () {
      closeTimers.delete(headerMenu);
      closeMenu(headerMenu);
    }, LEAVE_DELAY);
    closeTimers.set(headerMenu, t);
  }

  headerMenus.forEach(function (headerMenu) {
    headerMenu.addEventListener('mouseenter', function () { scheduleOpen(headerMenu); });
    headerMenu.addEventListener('mouseleave', function () { scheduleClose(headerMenu); });

    // Keep open when focus moves inside via keyboard
    headerMenu.addEventListener('focusin', function () {
      clearTimeout(closeTimers.get(headerMenu));
      closeTimers.delete(headerMenu);
    });
    headerMenu.addEventListener('focusout', function (e) {
      if (!headerMenu.contains(e.relatedTarget)) scheduleClose(headerMenu);
    });
  });

  // Esc closes everything
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    headerMenus.forEach(function (hm) { closeMenu(hm); });
  });

  // Click outside the header closes any open menu
  document.addEventListener('click', function (e) {
    headerMenus.forEach(function (hm) {
      if (!hm.contains(e.target)) closeMenu(hm);
    });
  });
})();
